import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";

const basePath = process.env.VUE_APP_PATH;

export default createRouter({
  history:
    process.env.NODE_ENV === "production"
      ? createWebHistory(basePath)
      : createWebHashHistory(basePath),
  routes: [
    {
      path: "/:catchAll(.*)*",
      redirect: "/home",
    },
    {
      path: "/:page",
      alias: "/:page/index.html",
      name: "page",
      component: () => import("@/views/PageView.vue"),
    },
    {
      path: "/road2050",
      alias: "/road2050/index.html",
      name: "road2050",
      component: () => import("@/components/charts/info-road-2050/ChartRoadTo2050.vue"),
    },
  ],
});
